import type { ExportJobStatus } from "@/types/api";

export function canDownloadZip(
  status: ExportJobStatus,
  invoiceCount?: number | null,
): boolean {
  if (status !== "SUCCESS") return false;
  // Empty from-filters jobs are successful but intentionally have no ZIP.
  if (invoiceCount != null && invoiceCount <= 0) return false;
  return true;
}
